import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { TypeChecker } from '@attain-apps/type-guards'

import * as state from '../../../../../../../../../state'
import * as shared from '../shared'

import * as filters from './filters'

/** Identifies this report to the configuration plugin. */
const REPORT_ID = ents.extra.space.Report.Id.UnassignedSponsoredAccounts

/**
 * Body of the Unassigned Sponsored Accounts report: the accounts themselves,
 * grouped by the organization they are aligned to, with the report's
 * configuration below them.
 */
@ngCore.Component({
  imports: [
    ds.input.checkbox.Component,
    ds.layout.widget.Component,
    ds.table.Component,
    filters.Component,
    shared.commentModal.Component,
  ],
  selector: 'atn-space-report-unassigned-sponsored-accounts',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.space.full.unassignedSponsoredAccounts.Collection} */
  public readonly unassignedSponsoredAccountsEc = ngCore.inject(
    state.space.full.unassignedSponsoredAccounts.Collection,
  )

  /** @see {@link state.space.reports.Collection} */
  private readonly _reportsEc = ngCore.inject(state.space.reports.Collection)

  /** @see {@link state.space.reports.plugins.configuration.Plugin} */
  public readonly configurationPlugin = this._reportsEc.plugins
    .lookup(state.space.reports.plugins.configuration.Plugin)
    .get()

  /** Configuration settings for this report. */
  public readonly configurationSg =
    this.configurationPlugin.selectors.getSettings(REPORT_ID).asSignal

  /** @see {@link state.space.reports.plugins.configuration.Plugin.selectors.isStandardUser} */
  public readonly isStandardUserSg =
    this.configurationPlugin.selectors.isStandardUser.asSignal

  /** Canonical table input for the unassigned sponsored accounts. */
  public readonly unassignedSponsoredAccountsTableConfig: ds.table.ec.Config.Input<state.space.full.unassignedSponsoredAccounts.TypeParams> =
    {
      collection: this.unassignedSponsoredAccountsEc,
      view: {
        pagination: true,
        title: 'Unassigned Sponsored Accounts',
      },
    }

  /** Whether an organization filter is currently narrowing the list. */
  public readonly hasAppliedFiltersSg = ngCore.computed(
    (
      appliedFilters = this.unassignedSponsoredAccountsEc.plugins.currentListPlugin.appliedParams.selectors.filters.asSignal(),
    ) => Object.values(appliedFilters ?? {}).some(TypeChecker.isNotNullish.raw),
  )

  /** Starts editing the Current List parameters. */
  public filtersClickHandler(): void {
    this.unassignedSponsoredAccountsEc.plugins.currentListPlugin.feature.actions.startEditingParams
      .from('Space.UnassignedSponsoredAccounts.Filters.Icon.Clicked')
      .dispatch()
  }

  /** Handles a change to the "Show Salary Information" checkbox. */
  public showSalaryInformationChangeHandler(value: boolean): void {
    this.configurationPlugin.actions.edit
      .from(
        'SpaceReport.UnassignedSponsoredAccounts.Configuration.ShowSalaryInformation.Changed',
      )
      .dispatch({ edit: { showSalaryInformation: value }, id: REPORT_ID })
  }
}
